import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana69Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">

  <rect width="1221" height="921" fill="url(#pattern0_1465_19738)"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}
    d="M559.382 405.9L515.144 419.512V460.346H595.112C589.44 446.735 577.077 417.81 572.993 411.005C568.91 404.199 562.217 404.766 559.382 405.9Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}
    d="M515.144 502.884V460.348H595.112L615.529 502.884H515.144Z" 
    fill={getFillByLot(3, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}
    d="M641.05 553.925L615.528 502.883H583.201V574.343L630.841 572.641C641.731 571.28 642.184 559.597 641.05 553.925Z" 
    fill={getFillByLot(4, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}
    d="M532.156 574.343H583.199V502.883H532.156V574.343Z" 
    fill={getFillByLot(5, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}
    d="M482.814 574.343H532.156V502.883H482.814V574.343Z" 
    fill={getFillByLot(6, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}
    d="M433.472 576.045L482.814 574.343V502.883H433.472V576.045Z" 
    fill={getFillByLot(7, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}
    d="M384.132 504.584L433.473 502.883V576.044L384.132 577.746V504.584Z" 
    fill={getFillByLot(8, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("9"))}
    d="M334.791 506.289L384.133 504.588V577.75L334.791 579.451V506.289Z" 
    fill={getFillByLot(9, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("10"))}
    d="M285.501 579.445H334.793L334.793 506.283H302.463L278.645 559.028C276.305 569.558 279.662 575.395 282.452 578.267C283.243 579.082 284.365 579.445 285.501 579.445Z" 
    fill={getFillByLot(10, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M322.884 484.163C310.634 489.608 304.168 501.177 302.467 506.282L409.657 504.58V453.537C385.837 461.477 335.134 478.718 322.884 484.163Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M469.206 434.822L409.656 453.538V504.581L469.206 502.88V434.822Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M515.141 419.516L469.202 434.829V502.886H515.141V419.516Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <defs>
    <pattern id="pattern0_1465_19738" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1465_19738" transform="matrix(0.00233381 0 0 0.003094 -4.0665 -2.16848)"/>
    </pattern>
    <image id="image0_1465_19738" width="4096" height="2304" href="/mz2.png"/>
  </defs>
</svg>

  );
};
